import axios, { type AxiosResponse } from 'axios'

import type {
    CreatePlateOrderPayload,
    MachinePlateItemsResponseSchema,
    PlateOrderHistoryParams,
    PlateOrderHistoryResponseSchema,
    PlateOrderReasonsResponseSchema
} from '@/api/schemas/reports/plateOrders'
import { API_ENDPOINTS } from '@/constants/apiEndpoints'

class ReportPlateOrdersQueries {
    getPlateOrderReasons(): Promise<AxiosResponse<PlateOrderReasonsResponseSchema>> {
        return axios.get<PlateOrderReasonsResponseSchema>(API_ENDPOINTS.PLATE_ORDERS.REASONS)
    }

    createPlateOrder(payload: CreatePlateOrderPayload): Promise<AxiosResponse<unknown>> {
        return axios.post<unknown>(API_ENDPOINTS.PLATE_ORDERS.ORDERS, payload)
    }

    getPlateOrderHistory(params: PlateOrderHistoryParams): Promise<AxiosResponse<PlateOrderHistoryResponseSchema>> {
        return axios.get<PlateOrderHistoryResponseSchema>(API_ENDPOINTS.PLATE_ORDERS.ORDERS, { params })
    }

    getMachinePlateItems(
        machineCode: string,
        limit: number,
        offset: number
    ): Promise<AxiosResponse<MachinePlateItemsResponseSchema>> {
        return axios.get<MachinePlateItemsResponseSchema>(
            `${API_ENDPOINTS.PLATE_ORDERS.MACHINE_PLATE_ITEMS}/${encodeURIComponent(machineCode)}`,
            {
                params: {
                    limit,
                    offset
                }
            }
        )
    }
}

export default new ReportPlateOrdersQueries()
